import Wrapsody from '../../images/wrapsody.svg'
import WrapsodyEco from '../../images/wrapsodyeco.svg'
import Drm from '../../images/drm.svg'

const data = [[
  {
    img:Wrapsody,
    title:'콘텐츠 기반 채팅 제공',
    sub:"문서 자산화 플랫폼 Wrapsdoy와 연동해<br/>협업 데이터 암호화와 Wrapping 된<br/>콘텐츠 기반 채팅 제공",
    href:"https://www.fasoo.com/products/wrapsody"
  },
  {
    img:WrapsodyEco,
    title:"워크그룹 기반 채팅 제공",
    sub:"외부 협업 플랫폼 Wrapsody eCo와 연<br/>동해 내/외부 협력 부서 및 업체를 포함한<br/>워크그룹 기반 채팅 제공",
    href:"https://www.fasoo.com/products/wrapsody-eco"
  },
  {
    img:Drm,
    title:"보안 기능 강화",
    sub:"통합 문서 보안 솔루션 Fasoo<br/>Enterprise DRM과 시너지를 통해 강력<br/>하고 세부적인 보안 기능 강화",
    href:"https://www.fasoo.com/products/fasoo-enterprise-drm"
  }],  
]

export default data;